import { useState } from 'react';
import { fetchWithAuth } from '../../../utils/apiAuth';
import config from '../../../config';

const apiBaseUrl = config.getApiUrl();

export const useQuizLeads = () => {
  const [quizLeads, setQuizLeads] = useState([]);
  const [quizLeadsLoading, setQuizLeadsLoading] = useState(false);
  const [quizLeadsError, setQuizLeadsError] = useState(null);
  const [quizLeadsPage, setQuizLeadsPage] = useState(0);
  const [quizLeadsRowsPerPage, setQuizLeadsRowsPerPage] = useState(10);

  const fetchQuizLeads = async () => {
    try {
      setQuizLeadsLoading(true);
      setQuizLeadsError(null);
      const response = await fetchWithAuth(`${apiBaseUrl}/api/quiz-leads`);
      setQuizLeads(response.data || response || []);
    } catch (err) {
      console.error('Error fetching quiz leads:', err);
      setQuizLeadsError(err.message);
    } finally {
      setQuizLeadsLoading(false);
    }
  };

  const handleQuizLeadsChangePage = (event, newPage) => {
    setQuizLeadsPage(newPage);
  };

  const handleQuizLeadsChangeRowsPerPage = (event) => {
    setQuizLeadsRowsPerPage(parseInt(event.target.value, 10));
    setQuizLeadsPage(0);
  };

  return {
    quizLeads,
    quizLeadsLoading,
    quizLeadsError,
    quizLeadsPage,
    quizLeadsRowsPerPage,
    fetchQuizLeads,
    handleQuizLeadsChangePage,
    handleQuizLeadsChangeRowsPerPage
  };
};
